module.exports = __webpack_public_path__ + "static/media/refresh.7f460069.svg";